import { useContext } from 'react'
import { VBar, type VBarProps } from '../../vbar/VBar'
import { VBarPositionContext } from './VBarPositionContext'
import { PositionedVBar } from './PositionedVBar'

export type VBarStackItemProps = VBarProps

/**
 * VBar component that renders a regular VBar when no parent VBarPositionContext is present,
 * or a PositionedVBar when the context is present.
 * The PositionedVBar will use the context's positioning properties to register itself
 * if it finds a parent VBarStack.
 */
export const VBarStackItem: React.FC<VBarStackItemProps> = props => {
  const context = useContext(VBarPositionContext)

  return context.isPositioned ? (
    <PositionedVBar
      {...props}
      id={context.id}
      top={context.top}
      anchorHeight={context.anchorHeight}
      left={context.left}
      width={context.width}
      ref={context.ref}
      zIndex={context.zIndex}
      dataset={context.dataset}
    />
  ) : (
    <VBar {...props} />
  )
}
